import React from "react";

const NewSchedule = ({ startDate }) => (
  <div className="container p-0">
    <div className="schedule-well mt-2 mb-2 text-center p-4">
      <h4>
        <i className="far fa-calendar-exclamation" /> A new schedule is
        available starting November 9th, 2026. Scroll past the current schedule
        to view the new schedule.
      </h4>
    </div>
  </div>
);

export default NewSchedule;
